import Parse from 'parse'
import { makeVar, useReactiveVar } from '@apollo/client'
import { updateIntercomUser } from '../../client/app/intercom'
import { _precacheLocalStorageCurrentUser } from './currentApolloUser'
/** @import { ReactiveVar } from "@apollo/client" */

/** @type {ReactiveVar<Parse.User<Parse.Attributes> | null>} */
const parseUserVar = makeVar(null)

/**
 * Should only be used as part of the parse initialization process
 */
export const _initCurrentUser = () => {
  // eslint-disable-next-line no-restricted-syntax
  const user = Parse.User.current()
  parseUserVar(user)
  _precacheLocalStorageCurrentUser(user)
  updateIntercomUser()
}

/**
 * @deprecated use the getCurrentCachedUser function instead
 */
export const getCurrentParseUser = () => parseUserVar()

/**
 * @deprecated use the useCurrentUser hook instead
 */
export const useCurrentParseUser = () => useReactiveVar(parseUserVar)

/**
 * @returns {string | undefined}
 */
export const useCurrentUserId = () => useCurrentParseUser()?.id

/**
 * @private do not use directly, use functions that use this function
 * @param {Parse.User<Parse.Attributes> | null} user
 */
export const _setCurrentUser = (user) => {
  parseUserVar(user)
}
